import { apiClient } from "./client";

export const getVendorProducts = ({ page = 1, limit = 15, search = "" } = {}) => {
  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit)
  });

  if (search.trim()) {
    query.set("search", search.trim());
  }

  return apiClient.get(`/products?${query.toString()}`);
};

export const getVendorProductById = (productId) => {
  return apiClient.get(`/products/${productId}`);
};

export const getVendorVariants = ({ page = 1, limit = 1000 } = {}) => {
  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit)
  });

  return apiClient.get(`/variants?${query.toString()}`);
};

export const placeVendorOrder = (items) => {
  return apiClient.post("/orders", { items });
};

export const getVendorOrders = ({ page = 1, limit = 10 } = {}) => {
  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit)
  });
  return apiClient.get(`/my-orders?${query.toString()}`);
};

export const getVendorOrderById = (orderId) => {
  return apiClient.get(`/my-orders/${orderId}`);
};
